import colors from '../../utils/colors';
import type { CommonSwitchProps, SwitchVariant } from './types';

export type GetBackgroundColorParams = {
  isChecked: CommonSwitchProps['isChecked'];
  variant: SwitchVariant;
};

export const getBackgroundColor = ({ isChecked, variant }: GetBackgroundColorParams) => {
  if (!isChecked) {
    return colors.a7neutral120;
  }

  return variant === 'pink' ? colors.pink120 : colors.orange100;
};
